import type { JsonDataWrapper, OdinDataRetrievalOptions, OdinDataSender } from '@myosh/odin-components';
import i18next from '../../../i18n';
import { getFormWorkflowSteps, getModuleForms, getModules } from '../../../utils/common-administration-utils';
import type { Rule, RuleResponse } from '../../../@types/rules';

export const transformRuleResponse = (data: RuleResponse): Rule => {
  const ruleData = data.result;
  return {
    ...ruleData,
    module: ruleData.module && { value: ruleData.module.id, text: ruleData.module.caption },
    moduleForm: ruleData.moduleForm && { value: ruleData.moduleForm.id, text: ruleData.moduleForm.caption },
    autoRuleType: autoRuleTypes.find((autoRuleType) => autoRuleType.value === ruleData.autoRuleType),
    autoRuleTrigger: triggerTypes.find((triggerType) => triggerType.value === ruleData.autoRuleTrigger),
    triggerWorkflowStep: ruleData.triggerWorkflowStep && {
      value: ruleData.triggerWorkflowStep.id,
      text: ruleData.triggerWorkflowStep.caption,
    },
  };
};

export const getRulesFieldOptionsData = async (
  subscriber: OdinDataSender<JsonDataWrapper>,
  options: OdinDataRetrievalOptions
) => {
  switch (options?.fieldId) {
    case 'autoRuleType':
      getAutoRuleTypes(subscriber, options);
      break;
    case 'autoRuleTrigger':
      getTriggerTypes(subscriber, options);
      break;
    case 'module':
      await getModules(subscriber, options);
      break;
    case 'moduleForm':
      await getModuleForms(subscriber, options);
      break;
    case 'triggerWorkflowStep':
      await getFormWorkflowSteps(subscriber, options);
      break;
    default:
      subscriber.sendData();
  }
};

const getAutoRuleTypes = async (subscriber: OdinDataSender<JsonDataWrapper>, options: OdinDataRetrievalOptions) => {
  if (options.page === 1) {
    subscriber.sendData({ data: autoRuleTypes });
  } else {
    subscriber.sendData();
  }
};

const getTriggerTypes = (subscriber: OdinDataSender<JsonDataWrapper>, options: OdinDataRetrievalOptions) => {
  if (options.page === 1) {
    subscriber.sendData({ data: triggerTypes });
  } else {
    subscriber.sendData();
  }
};

const triggerTypes = [
  {
    value: 'WORKFLOW_PROGRESS',
    text: i18next.t('record-changed-status'),
  },
  {
    value: 'RECORD_SAVE',
    text: i18next.t('record-edited'),
  },
];

const autoRuleTypes = [
  {
    value: 'CREATE_NEW',
    text: i18next.t('create-a-new-record'),
    defaultOption: false,
  },
  {
    value: 'UPDATE_EXISTING',
    text: i18next.t('update-an-existing-record'),
    defaultOption: false,
  },
  {
    value: 'UPDATE_PARENT_RECORDS',
    text: i18next.t('update-parent-records'),
    defaultOption: false,
  },
  {
    value: 'UPDATE_CURRENT_RECORD',
    text: i18next.t('update-current-record'),
    defaultOption: false,
  },
];
